"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDmsLogoffTabs = void 0;
var _reactRouterDom = require("react-router-dom");
var _log = require("../service/logging/log");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _Log = require("../constants/Log");
var _DmsTokenHook = require("../components/DmsTokenHook/DmsTokenHook");
var _LogOffContext = require("../context/LogOffContext");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* useDmsLogoffTabs Hook
*
* This hook provides a function to log the user out by clearing all stored session data
* and refreshing the application.
*
* @returns {Function} logoff - A function that clears local storage, session storage,
* resets credentials, and refreshes the page.
*
* @example
* const logoff = useDmsLogoffTabs();
* logoff(); // Logs out the user and refreshes the page.
*/

const useDmsLogoffTabs = () => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    logoffEnabled,
    logoffMessage
  } = (0, _LogOffContext.useLogoffContext)();
  const logoff = async () => {
    if (!logoffEnabled) {
      _sweetalert.default.fire({
        icon: "warning",
        title: _reactIntlUniversal.default.get("Warning").d("Warning"),
        text: logoffMessage || _reactIntlUniversal.default.get("LogoffIsDisabledOnThisScreen").d("Logoff is disabled on this screen"),
        confirmButtonText: _reactIntlUniversal.default.get("OK").d("OK")
      });
      return;
    }
    let token = (0, _DmsTokenHook.getToken)();
    (0, _log.log)(_reactIntlUniversal.default.get("UserLogoff").d("User logoff"), _reactIntlUniversal.default.get("Login").d("Login"), _Log.LogLevel.INFO, _Log.LogType.USER, null, token).catch(err => {
      console.error("Error in register log:", err);
    });
    localStorage.clear();
    sessionStorage.clear();
    (0, _DmsTokenHook.credentialsFlush)();
    setTimeout(() => {
      navigate(0);
    }, 200);
  };
  return logoff;
};
exports.useDmsLogoffTabs = useDmsLogoffTabs;